// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__fu9I3","title":"FrontImage_title__QjGQn"};